import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";

import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { ICurrencyPairCalendarPromiseLookupService } from "../ICurrencyPairCalendarPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { CcyPairLookupService } from "./CcyPairLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { Observable } from "rxjs";

@Injectable()
export class CurrencyPairCalendarReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.CurrencyPairCalendarImpl>
  implements ICurrencyPairCalendarPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(
      factory,
      CubiqTS.CurrencyPairCalendarImpl,
      "CurrencyPairCalendarImpl",
      CubiqTS.ModelUpdateImpl,
      true,
    );
  }

  public requestRun(ccyPairs: Array<string> | null): Promise<CubiqTS.CurrencyPairCalendarImpl> {
    throw new Error("TODO");
  }

  public getTdrNotification(): Observable<Set<string>> {
    throw new Error("TODO");
  }

  public getCalendarWithHolidays(
    base: string,
    nonBase: string,
    product: CubiqTS.Product,
  ): Promise<CubiqTS.CurrencyPairCalendar> {
    let request = new UiArguments("getCalendarWithHolidays");
    let arg1 = new FnArg(base, PRIMITIVE);
    let arg2 = new FnArg(nonBase, PRIMITIVE);
    let arg3 = new FnArg(product, PRIMITIVE);
    request.args = [arg1, arg2, arg3];
    return this.broker.runOnService(request, this.VALUE);
  }

  public getFixingDate(base: string, nonBase: string, brokenDate: Date): Promise<Date> {
    let request = new UiArguments("getFixingDate");
    let arg1 = new FnArg(base, PRIMITIVE);
    let arg2 = new FnArg(nonBase, PRIMITIVE);
    let arg3 = new FnArg(brokenDate, PRIMITIVE);
    request.args = [arg1, arg2, arg3];
    return this.broker.runOnService(request, PRIMITIVE);
  }
}
